import { lifiLogoUrl } from '../icons/lifi.js';
export const defaultBaseAccountConfig = {
    appName: 'LI.FI',
    appLogoUrl: lifiLogoUrl,
};
//# sourceMappingURL=baseAccount.js.map